
import {Component, Prop, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import DataFieldCache from "../../../../models/data.field.cache";
import {translate, translateFilter} from "@/auxillary/translation";
import {resolveConstraintExpression} from "@/auxillary/constraint.expression.resolver";

@Component({
  name: 'Hints',
  components: {
    OkDialog
  },
  filters: {
    translateFilter
  }
})
export default class Hints extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache
  private showHints = false;

/*@Watch('dataField', {immediate: true})
  onDataFieldChanged(dataField: DataFieldCache | undefined) {
    //this.hasAnyHints = (dataField?.hintRules && dataField?.hintRules?.length > 0) ?? false;
    //this.hasHiddenHints = this.hiddenHints.length > 0;
  }*/
  get hasVisibleHints() {
    return this.visibleHintRules.length > 0
  }

  public get visibleHintRules() {
    if (this.field.hintRules && this.field.hintRules.length > 0)
      return this.field.hintRules?.filter(r =>  !r.isDeleted &&
          (!r.constraintExpression || resolveConstraintExpression(r.constraintExpression, this.field)));
    return [];
  }

  get hasHiddenHints() {
    return this.hiddenHints.length > 0;
  }

  get hints() {
    return this.visibleHintRules?.filter(r => !r.definition.hidden) ?? [];
  }

  get hiddenHints() {
    return this.visibleHintRules?.filter(r => r.definition.hidden) ?? [];
  }

  get field() {
    return this.dataField;
  }

  translateHint(displayKey: string) {
    return translate(displayKey)
  }

}
